import type { IconProps } from './types';

export const VariableIcon = (props: IconProps) => {
  const {
    size = 18,
    width = size,
    height = size,
    color = 'currentColor',
    className,
  } = props;

  return (
    <svg
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      className={className}
    >
      <path
        d="M1.25 6.41667V2.54167C1.25 1.8283 1.8283 1.25 2.54167 1.25H6.41667"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5833 1.25H15.4583C16.1717 1.25 16.75 1.8283 16.75 2.54167V6.41667"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.75 11.5833V15.4583C16.75 16.1717 16.1717 16.75 15.4583 16.75H11.5833"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.41667 16.75H2.54167C1.8283 16.75 1.25 16.1717 1.25 15.4583V11.5833"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.00001 9.32292C8.82167 9.32292 8.67709 9.17834 8.67709 9C8.67709 8.82166 8.82167 8.67708 9.00001 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9.32292C9.17834 9.32292 9.32292 9.17834 9.32292 9C9.32292 8.82166 9.17834 8.67708 9 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5521 9.32292C12.3737 9.32292 12.2292 9.17834 12.2292 9C12.2292 8.82166 12.3737 8.67708 12.5521 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5521 9.32292C12.7304 9.32292 12.875 9.17834 12.875 9C12.875 8.82166 12.7304 8.67708 12.5521 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44795 9.32292C5.26961 9.32292 5.12503 9.17834 5.12503 9C5.12503 8.82166 5.26961 8.67708 5.44795 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.44791 9.32292C5.62625 9.32292 5.77082 9.17834 5.77082 9C5.77082 8.82166 5.62625 8.67708 5.44791 8.67708"
        stroke={color}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
